import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const aedCompanyLocaleModule: LocaleModule = {
  name: "aedCompany",
  messages: { en: en, it: it },
};
